import { Box, Switch, TextField, Typography, Divider, Link } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const glassCard = { p: 2, borderRadius: 3, bgcolor: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)", border: "1px solid rgba(229,231,235,0.6)", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" };
const fieldSx = { "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } };

const FileUploadTab = ({ skipOption, setSkipOption, errorMessage, setErrorMessage, settings, setSettings }) => {
  const s = settings || {};
  const cloud = s.cloudinary || {};

  return (
    <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={glassCard}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Skip Option</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Allow visitors to skip</Typography>
          </Box>
          <Switch checked={!!skipOption} onChange={(e) => setSkipOption(e.target.checked)} size="small" />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Allowed File Types</Typography>
        <Typography sx={{ fontSize: 11, color: "#6b7280", mb: 1.5 }}>JPG, PNG, GIF, PDF, DOC, DOCX, WebP</Typography>
        <TextField fullWidth label="Max File Size (MB)" type="number" size="small"
          value={s.uploadLimit ?? 10}
          onChange={(e) => setSettings({ ...s, uploadLimit: Number(e.target.value) || 10 })}
          sx={fieldSx} />
      </Box>

      <Box sx={glassCard}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
          <CloudUploadIcon sx={{ fontSize: 18, color: "#3b82f6" }} />
          <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Cloudinary Storage</Typography>
        </Box>
        <Typography sx={{ fontSize: 11, color: "#6b7280", mb: 1.5 }}>
          Upload files to your Cloudinary account. Need an account?{" "}
          <Link href="https://cloudinary.com" target="_blank" rel="noopener" sx={{ fontSize: 11 }}>
            Sign up free
          </Link>
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 1.2, bgcolor: "#f9fafb", borderRadius: 2, border: "1px solid #e5e7eb", mb: 1.5 }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 12, color: "#1f2937" }}>Enable Cloudinary</Typography>
            <Typography sx={{ fontSize: 10, color: "#6b7280" }}>When off, files are stored as base64 in the chat (not recommended for large files)</Typography>
          </Box>
          <Switch
            size="small"
            checked={!!cloud.enabled}
            onChange={(e) => setSettings({ ...s, cloudinary: { ...cloud, enabled: e.target.checked } })}
          />
        </Box>

        <TextField
          fullWidth size="small"
          label="Cloud Name"
          placeholder="your-cloud-name"
          value={cloud.cloudName || ""}
          onChange={(e) => setSettings({ ...s, cloudinary: { ...cloud, cloudName: e.target.value } })}
          sx={{ ...fieldSx, mb: 1.5 }}
        />
        <TextField
          fullWidth size="small"
          label="Upload Preset (unsigned)"
          placeholder="ml_default"
          value={cloud.uploadPreset || ""}
          onChange={(e) => setSettings({ ...s, cloudinary: { ...cloud, uploadPreset: e.target.value } })}
          sx={{ ...fieldSx, mb: 1.5 }}
        />
        <TextField
          fullWidth size="small"
          label="Folder (optional)"
          placeholder="chatbot-uploads/"
          value={cloud.folder || ""}
          onChange={(e) => setSettings({ ...s, cloudinary: { ...cloud, folder: e.target.value } })}
          sx={fieldSx}
        />
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Error Message</Typography>
        <TextField fullWidth placeholder="Please upload a valid file" value={errorMessage || ""} size="small"
          onChange={(e) => setErrorMessage(e.target.value)}
          sx={fieldSx} />
      </Box>
    </Box>
  );
};

export default FileUploadTab;
